import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" fill=\"none\" id=\"icon-close\">\r\n  <path d=\"M1 1L29 29\" stroke=\"currentColor\" stroke-width=\"1.33333\" stroke-miterlimit=\"10\" />\r\n  <path d=\"M1 29L29 1\" stroke=\"currentColor\" stroke-width=\"1.33333\" stroke-miterlimit=\"10\" />\r\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol